export const dropdownStyles = (zIndex: number) => ({
  borderBottomLeftRadius: '25px',
  borderBottomRightRadius: '25px',
  zIndex,
});
